import { render, staticRenderFns } from "./accountSettingModal.vue?vue&type=template&id=2042c0ec&"
import script from "./accountSettingModal.vue?vue&type=script&lang=js&"
export * from "./accountSettingModal.vue?vue&type=script&lang=js&"
import style0 from "./accountSettingModal.vue?vue&type=style&index=0&id=2042c0ec&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.10.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports